import { push as pushLocation, goBack, replace } from "react-router-redux";
/* --- Action names --- */
export const RESET_MESSAGES = "reset-messages";
export const MISC_ACCTS_ACTIONS = {
    RESET_MESSAGES: "reset-messages-accts"
};
export const MISC_AUTH_ACTIONS = {
    RESET_MESSAGES: "reset-messages-auth",
    TOGGLE_CAPTCHA: "auth-toggle-captcha"
};
export const MISC_CONTACT_ACTIONS = {
    RESET_MESSAGES: "reset-messages-contact"
};
export const MISC_PROFILE_ACTIONS = {
    RESET_MESSAGES: "reset-messages-profile"
};
export const MISC_VALIDATION_ACTIONS = {
    RESET_MESSAGES: "reset-messages-validation"
};
/**
 * Updates route
 *
 * @method goToUrl
 * @param {String} url URL to go to
 * @returns {Function} Redux thunk
 */
export const goToUrl = (url) => (dispatch) => {
    dispatch(pushLocation(url));
};
/**
 * Resets status messages
 *
 * @method resetMessages
 * @param {String} domain Resets status messages for this domain
 * @returns {Function} Redux thunk
 */
export const resetMessages = (domain) => (dispatch) => {
    switch (domain) {
        case "auth":
            dispatch({
                type: MISC_AUTH_ACTIONS.RESET_MESSAGES
            });
            break;
        case "accts":
            dispatch({
                type: MISC_ACCTS_ACTIONS.RESET_MESSAGES
            });
            break;
        case "contact":
            dispatch({
                type: MISC_CONTACT_ACTIONS.RESET_MESSAGES
            });
            break;
        case "profile":
            dispatch({
                type: MISC_PROFILE_ACTIONS.RESET_MESSAGES
            });
            break;
        case "validation":
            dispatch({
                type: MISC_VALIDATION_ACTIONS.RESET_MESSAGES
            });
            break;
    }
    dispatch({
        type: RESET_MESSAGES,
        payload: domain
    });
};
export const backToUrl = (url) => (dispatch, getState) => {
    const { previousLocation } = getState().routing;
    if (previousLocation != null
        && previousLocation.pathname != null
        && previousLocation.pathname.toLowerCase() === url) {
        dispatch(goBack());
    }
    else {
        dispatch(replace(url));
    }
};



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/misc/miscActions.ts